import React from 'react';
import { Alert, Button, Card, Spin, Tooltip } from "antd";
import { Table } from "../../../shared/ViewportTable";
import { useInvoiceStep } from '../../viewmodels/useInvoiceStep';
import { money, actionReason } from '../../utilities/paymentPresentation';
import { paymentErrorMessage } from '../../utilities/paymentErrors';
const columns = [
  { title: 'Item', dataIndex: 'description', key: 'description' },
  { title: 'Qty', dataIndex: 'quantity', key: 'quantity', align: 'right', width: 80, render: value => <span className="pv2-num">{value}</span> },
  { title: 'Line total', dataIndex: 'line_total_amount', key: 'total', align: 'right', width: 160, render: value => <span className="pv2-num">{money(value)}</span> },
];
// Lines and totals come from the server preview; nothing is calculated here.
export default function InvoiceStep({ queryPk, projection, reload }) {
  const vm = useInvoiceStep(queryPk, projection, reload);
  const action = vm.acceptance.allowed ? vm.acceptance : vm.locking;
  const buttonLabel = vm.acceptance.allowed ? vm.canLockOnAcceptance ? 'Customer accepted — lock price' : 'Customer accepted' : 'Lock price';
  return <Card size="small" className="pv2-invoice" title="Invoice price" extra={<span className="pv2-muted">From the last quote shared with the customer</span>}>
    <div className="pv2-form">{(vm.error || vm.previewError) && <Alert type="error" showIcon message={paymentErrorMessage(vm.error || vm.previewError)} />}</div>
    {vm.preview ? <>
      <Table size="small" pagination={false} columns={columns} dataSource={(vm.preview.lines || []).map((line, index) => ({ ...line, key: line.id || index }))} locale={{ emptyText: 'No invoice lines' }} />
      <dl className="pv2-totals">
        <dt>Subtotal</dt><dd>{money(vm.preview.subtotal_amount)}</dd>
        <dt>VAT</dt><dd>{money(vm.preview.tax_amount)}</dd>
        <dt className="pv2-total">Total</dt><dd className="pv2-total">{money(vm.preview.total_amount)}</dd>
      </dl>
    </> : action.allowed && !vm.previewError ? <div className="pv2-loading"><Spin /></div> : null}
    {action.reason_code !== 'PERMISSION_REQUIRED' && <div className="pv2-form-footer">
      <Tooltip title={action.allowed ? null : actionReason(action)}><Button type="primary" disabled={!action.allowed || !vm.preview || vm.busy || !!vm.result} loading={vm.busy} onClick={vm.acceptance.allowed ? vm.accept : vm.lock}>{buttonLabel}</Button></Tooltip>
    </div>}
  </Card>;
}
